import { Button, Container, Paper, PasswordInput, Stack, Text, TextInput, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { signInWithEmailAndPassword } from 'firebase/auth';
import { FirebaseError } from "firebase/app";
import { useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import { authFirebase } from "../../config";
import {  IconLock, IconLogin, IconMail } from "@tabler/icons-react";
import { useUserStore } from "../../store/user.store";
import { useState } from "react";

const LoginPage = () => {
    const navigate = useNavigate();
    const setUIDAndToken = useUserStore(state => state.setUIDAndToken);
    const [submitting, setSubmitting] = useState(false);

    const form = useForm({
        initialValues: { 
            email: '',
            password: '',
        },
        validate: {
            email: (value: string) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
        },
    });
    
    return (
        <Container size={460} py="xl">
            <Paper withBorder radius="xl" p="xl" shadow="xs">
                <Stack gap="lg">
                    <div>
                        <Title order={2}>Sign In</Title>
                        <Text c="var(--my-dark)" size="sm" mt={4}>
                            Use your clinic admin account to manage appointments and patient records.
                        </Text>
                    </div>
                    <form
                        onSubmit={form.onSubmit(async (values) => {
                            try {
                                setSubmitting(true);
                                const userCredential = await signInWithEmailAndPassword(
                                    authFirebase,
                                    values.email,
                                    values.password,
                                );
                                const user = userCredential.user;
                                const token = await user.getIdToken();

                                setUIDAndToken(user.uid, token);

                                notifications.show({
                                    title: 'Success',
                                    message: 'You have successfully logged in',
                                    color: 'clinic',
                                });
                                navigate('/dashboard');
                            } catch (error) {
                                const errorMessage = error instanceof FirebaseError || error instanceof Error
                                    ? error.message
                                    : 'Unable to sign in right now.';
                                console.error(error);
                                notifications.show({
                                    title: 'Error',
                                    message: errorMessage,
                                    color: 'accent',
                                });
                            } finally {
                                setSubmitting(false);
                            }
                        })}
                    >
                        <Stack gap="md">
                            <TextInput
                                type='email'
                                label="Email Address"
                                required
                                leftSection={<IconMail size={18} />}
                                placeholder="Enter your email"
                                {...form.getInputProps('email')}
                                size="md"
                            />
                            <PasswordInput
                                required
                                label="Password"
                                leftSection={<IconLock size={18} />}
                                placeholder="Enter your password"
                                size="md"
                                {...form.getInputProps('password')}
                            />
                            <Button
                                fullWidth
                                leftSection={<IconLogin size={18} />}
                                type="submit"
                                radius="xl"
                                size="md"
                                loading={submitting}
                                color="clinic"
                            >
                                Sign In
                            </Button>
                        </Stack>
                    </form>
                </Stack>
            </Paper>
        </Container>
    );
};

export default LoginPage;
